import { ViewChild } from '@angular/core';
import { GridOptions } from 'ag-grid-community';
import { Component, Input } from '@angular/core';
import { ProvidersService, CommonService } from 'fccore2';
import { FcinputComponent } from '../fcinput';
import { FcmodalOption } from '../fcmodal/fcmodallist.component';
import { FCEVENT } from '../fc';
import { FclistmodalComponent } from './fclistmodal.component';
import { FormBuilder } from '@angular/forms';
import {
  GRIDOPTIONS,
  FclistsearchConfig,
  FclistsearchmodalOption,
  GRIDOPSLOCALE,
  SEARCHLAYOUT,
  getFieldsConfByAppid,
  fclistOption,
  selectRowById
} from '../business/fclistdata.business';
import { FcEvent } from '../business/fcevent.event';
/**
 * fc-listdataåè¡¨ç»ä»¶
 * å¤æçæ°æ®åè¡¨ã
 * æ¯æè¡¨å¤´ï¼æä½åï¼å¤éæ¡
 * äºä»¶ï¼
 * 1.æ¥æ¾äºä»¶ï¼search
 * 2.éç½®äºä»¶ï¼reset
 * 3.éä¸­äºä»¶ï¼selected
 * 4.è¡ç¹å»äºä»¶ï¼rowclick
 * 5.ååæ ¼ç¹å»äºä»¶ï¼cellClick
 * 6.è¡åå»äºä»¶ï¼rowDoubleClick
 * 7.ä¿®æ¹äºä»¶ï¼modify
 */
@Component({
  // tslint:disable-next-line:component-selector
  selector: 'fc-listdata',
  template: `
    <div class="fc-listdata">
        <div class="fc-flex">
            <div *ngIf="_options!==undefined" class="fc-listdata-content">
                <ag-grid-angular  [localeText]="_gridOptions.localeText"
                            style="width: 100%; height: 100%;"
                            [pagination]="false"
                            [quickFilter]="fcQuickFilter"
                            [paginationPageSize]="fcOption.fcPaginationPageSize"
                            [rowData]="data"
                            [autoSizePadding]="true"
                            [rowClassRules]="fcRowClassRules"
                            [class]="fcOption.fcClass"
                            [columnDefs]="fcOption.fcFields"
                            [rowGroupPanelShow]="fcOption.fcRowGroupPanelShow"
                            [enableFilter]="fcOption.fcEnableFilter"
                            [context]="fcContext"
                            enableValue="true"
                            enableRowGroup="true"
                            singleClickEdit="true"
                            [rowHeight]="fcOption.fcRowHeight"
                            (cellValueChanged)="_cellStopEdit($event);"
                            [checkboxSelection]="fcOption.fcCheckboxSelection"
                            [rowSelection]="fcOption.fcRowSelection"
                            [enableColResize]="fcOption.fcEnableColResize"
                            [animateRows]="true"
                            (firstDataRendered)="firstDataRendered('firstDataRendered',$event)"
                            [treeData]="fcOption.fcTreeData||false"
                            [getDataPath]="fcOption.fcGetDataPath"
                            [groupDefaultExpanded]="fcOption.fcGroupDefaultExpanded"
                            [autoGroupColumnDef]="fcOption.fcAutoGroupColumnDef"
                            (selectionChanged)="_selected($event)"
                            (rowClicked)="_rowClick($event);"
                            (cellClicked)="_cellClick($event);"
                            (rowDoubleClicked)="_rowDoubleClicked($event);"
                            [rowMultiSelectWithClick]="true"
                            [enableSorting]="fcOption.fcEnableSorting"
                            (gridReady)="_gridReady($event)">
                </ag-grid-angular>
            </div>
            <div *ngIf="_options===undefined" class="fc-listdata-content">
                <ag-grid-angular [localeText]="_gridOptions.localeText"
                            style="width: 100%; height: 100%;"
                            [pagination]="false"
                            [quickFilter]="fcQuickFilter"
                            [paginationPageSize]="fcOption.fcPaginationPageSize"
                            [rowData]="data"
                            [rowClassRules]="fcRowClassRules"
                            [autoSizePadding]="true"
                            [class]="fcOption.fcClass"
                            (firstDataRendered)="firstDataRendered('firstDataRendered',$event)"
                            [columnDefs]="fcOption.fcFields"
                            [rowGroupPanelShow]="fcOption.fcRowGroupPanelShow"
                            [enableFilter]="fcOption.fcEnableFilter"
                            enableValue="true"
                            [context]="fcContext"
                            enableRowGroup="true"
                            singleClickEdit="true"
                            [rowHeight]="fcOption.fcRowHeight"
                            (cellValueChanged)="_cellStopEdit($event);"
                            [checkboxSelection]="fcOption.fcCheckboxSelection"
                            [rowSelection]="fcOption.fcRowSelection"
                            [enableColResize]="fcOption.fcEnableColResize"
                            [animateRows]="true"
                            [treeData]="fcOption.fcTreeData||false"
                            [groupDefaultExpanded]="fcOption.fcGroupDefaultExpanded"
                            [autoGroupColumnDef]="fcOption.fcAutoGroupColumnDef"
                            [getDataPath]="fcOption.fcGetDataPath"
                            (selectionChanged)="_selected($event)"
                            (rowClicked)="_rowClick($event);"
                            [rowMultiSelectWithClick]="true"
                            (cellClicked)="_cellClick($event);"
                            (rowDoubleClicked)="_rowDoubleClicked($event);"
                            [enableSorting]="fcOption.fcEnableSorting"
                            (gridReady)="_gridReady($event)">
                </ag-grid-angular>
            </div>
            <fc-pagination *ngIf="fcOption.fcPagination" [fcTotal]="pageTotal"
            [fcPageIndex]="pageNum"
            [fcPageSize]="pageSize" fcShowQuickJumper='Y'
            [fcSize]="fcSize" [fcSample]="fcOption.fcSample" [fcShowSizeChanger]="'Y'"
             [fcPageSizeSelectorValues]="fcPageSizeSelectorValues"
             (fcEvent)="paginationEvent($event)"></fc-pagination>
        </div>
    </div>
    `,
  styles: [
    `
        .fc-listdata{
        width: 100%;
        height:100%;
        }
        .hidden{
            display:none;
        }
        .show{
            display:block;
        }
        .fc-flex{
            width: 100%;
            height:100%;
            display: -moz-box;
            display:-webkit-flex;
            display: -ms-flexbox;
            -moz-box-orient: vertical;
            -webkit-flex-direction:column;
            -ms-flex-direction:column;
        }
        .fc-search {
            display:block;
        }
        .fc-listdata-content {
            -moz-box-flex: 1;
            -webkit-flex:1;
            -ms-flex:1;
            height:85%;
            margin-bottom:5px;
        }
        :host ::ng-deep .fc-listdata .fc-layoutgroup .fc-content{
            margin-bottom:20px;
        }
        :host ::ng-deep .ag-blue .ag-paging-row-summary-panel {
            width:auto;
        }
        :host ::ng-deep .ag-blue .ag-paging-button {
            padding-left: 10px;
            padding-right: 10px;
            border-radius: 2px;
            cursor: pointer;
            background: #108EE9;
            border: 1px solid #108EE9;
            color: #ffffff;
            transition: all .3s cubic-bezier(.645,.045,.355,1)
        }
        :host ::ng-deep .ag-blue .ag-paging-button:hover{
            background-color: #49a9ee;
            border-color: #49a9ee;
        }
        :host ::ng-deep .ag-blue ag-paging-page-summary-panel {
            white-space: nowrap;
        }
        :host ::ng-deep .ag-blue .ag-row-odd {
            background: #F8F8F8;
        }
        :host ::ng-deep .ag-blue .ag-row-selected {
            background:rgba(0,0,0,.1);
        }
        :host ::ng-deep .ag-blue .ag-row-hover {
            background:rgba(0,0,0,.05);
        }
        :host ::ng-deep .ag-blue .ag-ltr .ag-cell-no-focus {
            border-right: 1px solid #eeee;
        }
        :host ::ng-deep .ag-blue .ag-cell-no-focus {
            border-bottom: 1px solid #eeee;
        }
        :host ::ng-deep .ag-blue .ag-cell-no-focus:hover {
            background: rgba(0,0,0,.05);
        }
        :host ::ng-deep .ag-blue .ag-cell-focus {
            border-color: #108EE9;
        }
        :host ::ng-deep .ag-blue .ag-header {
            background: #2B88FF;
            color:#333333;
            border-bottom:1px solid #8B8C8D;
            line-height:25px;
            text-align:center
        }
        :host ::ng-deep .ag-blue .ag-paging-panel{
            text-align:center;
        }
        :host ::ng-deep .ag-blue .ag-paging-panel{
            padding: 4px 4px 0;
        }
        :host ::ng-deep .ag-blue .ag-cell{
            text-align:left;
        }
        :host ::ng-deep .text-left{
            text-align:left;
        }
        :host ::ng-deep .text-center{
            text-align:center;
        }
        :host ::ng-deep .text-right{
            text-align:right;
        }
        :host ::ng-deep .text-link span span{
            text-decoration:none;
            color:blue;
            cursor: pointer;
        }
        :host ::ng-deep .ag-blue .ag-column-drop-horizontal {
            padding: 2px;
            border-top: 1px solid #7d7d7d;
            border-left: 1px solid #7d7d7d;
            border-right: 1px solid #7d7d7d;
        }
        :host ::ng-deep .ag-blue .ag-root{
            border:none;
            border:1px solid #7d7d7d;
        }
        :host ::ng-deep .ag-blue .ag-ltr .ag-header-cell{
            border-right:1px solid #eeee;
        }
        :host ::ng-deep .ag-blue .ag-header-cell-label{
            display:flex;
            justify-content:center;
        }
    `
  ]
})
export class FclistdataComponent extends FcinputComponent {
  // æ°æ®åå®¹ç¬¦åå¨æäºèå´çæ¶åæ¾ç¤ºæäºæä½æé®ï¼ä¸ç¬¦ååä¸æ¾ç¤ºï¼
  // å·ä½å®æ½æ¹æ¡ä¸ºå¨ç»ä»¶fclistdataç»ä»¶ä¸­å¢å æ°å±æ§ï¼
  // fcViewActionStrategy="[{FIELDCODE:'STATUS',FIELDVALUE:'èµ·è',BUTTONS:['listAdd','listDelete','listView',]}]"
  @Input()
  fcViewActionStrategy: string;
  // tslint:disable-next-line:variable-name
  public _gridApi;
  // tslint:disable-next-line:variable-name
  public _gridColumnApi;
  // tslint:disable-next-line:variable-name
  public _gridOptions: GridOptions = {};
  // tslint:disable-next-line:variable-name
  private _selectIds: string[];
  // tslint:disable-next-line:variable-name
  private _selectItems: any[];
  // tslint:disable-next-line:variable-name
  private _selectIndex: number;
  // tslint:disable-next-line:variable-name
  _options: FcmodalOption;
  @Input() externalFilter: (node) => boolean;
  @Input()
  fcRowData: any[];
  @Input()
  fcOption: GRIDOPTIONS;
  // tslint:disable-next-line:variable-name
  _condition: any = {};
  @ViewChild('FclistmodalComponent', { static: false })
  fclistmodal: FclistmodalComponent;
  /** å­æ®µå */
  @Input()
  fcSearchConfig: FclistsearchConfig;
  /** å­æ®µå */
  @Input()
  fcContext: any;
  @Input()
  fcRowClassRules: any;
  // tslint:disable-next-line:variable-name
  _modalOption: FclistsearchmodalOption;
  /** æ»é¡µæ° */
  // tslint:disable-next-line:variable-name
  pageTotal: number;
  @Input()
  fcTotalSize: number;
  /** åé¡µå¤§å° */
  @Input()
  fcPageSize: number;
  // tslint:disable-next-line:variable-name
  pageSize: number;
  /** åé¡µç´¢å¼ */
  // tslint:disable-next-line:variable-name
  pageNum: string;
  /** æå®æ¯é¡µå¯ä»¥æ¾ç¤ºå¤å°æ¡ */
  @Input()
  fcPageSizeSelectorValues: number[];
  // tslint:disable-next-line:variable-name
  private _tempCopyInfo: any = {};
  // éä¸­çåå®¹
  @Input()
  fcSelectedValues: string;
  // éä¸­çå­æ®µåç§°ï¼ä¸fcSelectedValueséåä½¿ç¨ï¼
  @Input()
  fcSelectedFieldName: string;
  // å­æ®µçæ¸²ææ¹å¼å®ä¹
  @Input()
  fcFieldsRender: any;
  // æ¥è¯¢è¿æ»¤æ¡ä»¶
  @Input()
  fcQuickFilter: string;
  // èªå¨æ¥è¯¢
  @Input()
  fcAutoSearch: string;
  // ä¸å¡è§åï¼ä¸åä¸å¡è§ååºç°çæé®ä¸ä¸æ ·
  @Input()
  fcBustype: string;
  constructor(public provider: ProvidersService, private fb: FormBuilder) {
    super(provider, 'fc-listdata');
    this._gridOptions = {};
    this._gridOptions.localeText = GRIDOPSLOCALE.localeText;
    this._gridOptions.icons = GRIDOPSLOCALE.icons;
    this._modalOption = {
      fcAppid: '',
      fcTitle: '',
      fcType: '',
      fcCondition: '{}'
    };
    this.fcSearchConfig = { fcValidate: undefined, fcFields: undefined };
    /** é¡µç é»è®¤ç¬¬ä¸é¡µ */
    this.pageNum = '1';
    this.pageSize = 20;
    this.pushDestroy(
      CommonService.subscribe(this.fcUuid + FcEvent.fclistdata.fclistdataShowFields, param => {
          if (param.param) {
            this.fcOption.fcShowFields = param.param;
            this.fcOption.fcFields = getFieldsConfByAppid(this, this.fcBustype, this.fcAppid, this.fcOption);
          }
        },
      )
    );
  }
  ngOnChanges(param) {
    super.ngOnChanges(param);
  }
  ngOnInit() {
    if (this.externalFilter !== undefined) {
      this._gridOptions.doesExternalFilterPass = this.externalFilter;
      this._gridOptions.isExternalFilterPresent = () => {
        return true;
      };
    }
  }
  @Input()
  set options(modalOption: FcmodalOption) {
    this._options = modalOption;
    this.fcOption = modalOption.options;
    this.fcRowData = modalOption.rowData;
    this.fcAppid = modalOption.appId;
    this.fcCondition = modalOption.condition;
    this.fcViewActionStrategy = modalOption.viewActionStrategy;
    this.ngOnChanges({});
  }
  _afterParentInit(param: any) {
    // å½æ°æ®è¿æ»¤æ¡ä»¶æ¹åçæ¶åæ§è¡
    if (param.fcQuickFilter &&  param.fcQuickFilter.currentValue !== param.fcQuickFilter.previousValue
      && !param.fcQuickFilter.firstChange) {
      setTimeout(() => {
        this._gridApi.setQuickFilter(this.fcQuickFilter);
      }, 10);
      return;
    }
    if (param.fcOption === undefined || param.fcOption && param.fcOption.firstChange) {
      if (this.fcOption === undefined) {
        this.fcOption = Object.assign([], fclistOption);
      }
    }
    // å½æ°æ®è¿æ»¤æ¡ä»¶æ¹åçæ¶åæ§è¡
    if (param.fcAppid &&  param.fcAppid.currentValue !== param.fcAppid.previousValue) {
        this.fcApp = this.appService.apps[param.fcAppid.currentValue];
        if (this.fcOption.fcPaginationPageSize === undefined) {
          if (this.fcApp) {
            this.fcOption.fcPaginationPageSize = this.fcApp.PSIZE;
          } else {
            this.fcOption.fcPaginationPageSize = 50;
          }
        }
        this.fcOption.fcFields = undefined;
        this.fcOption.fcFields = getFieldsConfByAppid(this, this.fcBustype, param.fcAppid.currentValue, this.fcOption);
    }
    if (this.fcOption.fcFields) {
      this.fcOption.fcFields = getFieldsConfByAppid(this, this.fcBustype, null, this.fcOption);
    }
    if (this.fcOption.fcOrder === undefined && this.fcApp !== undefined) {
      this.fcOption.fcOrder = this.fcApp.SORTBY;
    }
    this._selectIds = [];
    this._selectItems = [];
    this._selectIndex = 1;
    // éä¸­çå¯¹è±¡çæ è®°å¼
    if (this.fcSelectedValues) {
      this._selectIds = this.fcSelectedValues.split(',');
    }
    // éä¸­çå¯¹è±¡çæ è®°å¼å¯¹åºçkey
    if (!this.fcSelectedFieldName) {
      this.fcSelectedFieldName = 'ID';
    }
    if (this.fcPageSize !== undefined && this.fcPageSize !== null) {
      this.pageSize = this.fcPageSize;
    }
    if (this.fcOption.fcPaginationPageSize === undefined) {
      this.fcOption.fcPaginationPageSize = 20;
    }
    if (this.fcOption.fcPagination) {
      this.pageSize = Number(this.fcOption.fcPaginationPageSize);
    }
    // è¡é«
    if (this.fcOption.fcRowHeight === undefined) {
      this.fcOption.fcRowHeight = 23;
    }
    if (this.fcCondition === undefined || this.fcCondition.length === 0) {
      this._condition = {};
    } else if (typeof this.fcCondition === 'string') {
      this._condition = JSON.parse(this.fcCondition);
    } else {
      this._condition = this.fcCondition;
    }
    if (!this.fcOption.fcPagination) {
      this.fcReflesh();
    } else {
      /** æ¥è¯¢æ¡ä»¶æ¹åæ¶ï¼è·³è½¬å°ç¬¬ä¸é¡µ */
      if (this.pageNum !== this._condition.PAGENUM) {
        this.pageNum = '1';
      }
      this.fcReflesh();
    }
  }
  _getFormControl(name): any {
    return this.fcSearchConfig.fcValidate.controls[name];
  }
  /**
   * ç¹å»åé¡µäºä»¶
   * @param event shij
   */
  paginationEvent(event: FCEVENT) {
    switch (event.eventName) {
      case 'pageSizeChange':
        /** æ¯é¡µæ¾ç¤ºå¤å°æ¡ */
        this.pageSize = event.param;
        if (this.fcOption.fcPagination) {
          this.fcReflesh();
        }
        this.event('pageSizeChange', this.pageSize);
        break;
      case 'jumpPage':
        /** è·³å°ç¬¬å é¡µ,ç¬¬ä¸æ¬¡è¿æ¥æ¶ä¸è¦è§¦åï¼å¦åfcReflesh()ä¼æ§è¡ä¸¤æ¬¡ */
        this.pageNum = event.param + '';
        if (this.fcOption.fcPagination) {
          this.fcReflesh();
        }
        this.event('jumpPage', this.pageNum);
        break;
    }
  }
  /**
   * æ¥è¯¢
   */
  public fcReflesh(): void {
    if (this.fcAppid && this.fcAppid !== '') {
      const fieldDic = this.appService.getDicByAppid(this.fcAppid);
      /** å¯ç¨èªå®ä¹åé¡µ */
      if (this.fcOption.fcPagination) {
        if (
          this.fcPageSize === undefined &&
          this.fcApp !== undefined &&
          this.fcApp !== null
        ) {
          this.fcPageSize = this.fcApp.PSIZE;
        }
        this._condition = Object.assign(this._condition, {
          PAGENUM: this.pageNum,
          PAGESIZE: this.pageSize
        });
      }
      /** åé¨èªå¸¦æ¥è¯¢æ¡ä»¶ */
      if (
        this.fcSearchConfig &&
        this.fcSearchConfig.fcValidate &&
        this.fcSearchConfig.fcValidate.value
      ) {
        this._condition = Object.assign(this._condition, this.fcSearchConfig.fcValidate.value);
      }
      this._condition.AID = this.fcAppid;
      if (this.fcAutoSearch === undefined || this.fcAutoSearch === 'Y'  ) {
        this.pushDestroy(
          this.daoService
            .getFromApi(
              this.fcUrl,
              Object.assign({}, this.fcRequestParam, this._condition)
            )
            .subscribe(result => {
              if (result.CODE === '0' || (result.DATA && result.DATA.length !== 0)) {
                this.fcTotalSize = result.TOTALSIZE;
                this.processData(fieldDic, result.DATA, result.TOTALSIZE);
              } else {
                this.fcRowData = [];
                this.data = [];
                this.pageTotal = 0;
              }
            })
        );
      } else {
        this.processData(fieldDic, this.fcRowData, this.fcTotalSize);
      }
    } else {
      if (this.fcAutoSearch || this.fcAutoSearch === 'Y'  ) {
        this.pushDestroy(
          this.daoService
            .getFromApi(
              this.fcUrl,
              Object.assign({}, this.fcRequestParam, this._condition)
            )
            .subscribe(result => {
              if (result.CODE === '0' || (result.DATA && result.DATA.length !== 0)) {
                this.fcTotalSize = result.TOTALSIZE;
                this.processData(null, result.DATA, result.TOTALSIZE);
              } else {
                this.fcRowData = [];
                this.data = [];
                this.pageTotal = 0;
              }
            })
        );
      } else {
        this.processData(null, this.fcRowData, this.fcTotalSize);
      }
    }
  }
  /**
   *
   */
  processData(fieldDic: any[], data: any[], totalSize: number) {
    data.forEach((item, index) => {
      item.ROWNUM = index + 1;
      /** åé¡µåºå·è¿ç»­ */
      if (this.fcOption.fcPagination === true) {
        item.ROWNUM =
          Number(this.pageNum) * this.pageSize -
          this.pageSize +
          index +
          1;
      }
      item.DOACTION = {
        providers: this.provider,
        appId: this.fcAppid,
        parentComponent: this
      };
      if (fieldDic) {
        fieldDic.forEach(dic => {
          const dicdesc = this.appService.getDicdescByFieldCode(
            dic,
            item[dic.FIELDCODE]
          );
          if (dicdesc) {
            Object.assign(item, dicdesc);
          }
        });
      }
    });
    this.data = data;
    this.event(FcEvent.fclistdata.fclistdataDataLoaded, data);
    if (this._gridApi && this._selectIds.length > 0) {
      selectRowById(
        this._gridApi,
        this._selectIds,
        this.fcSelectedFieldName
      );
    }
    this.pageTotal = totalSize;
  }
  /**
   * æ ¹æ®idå é¤éåçå¯¹è±¡
   * @param ids idéå
   */
  deleteRowDataById(ids: string[]) {
    if (ids.length !== 0) {
      ids.forEach(id => {
        this.fcRowData = this.fcRowData.filter(item => item.ID !== id);
        this.data = this.data.filter(item => item.ID !== id);
      });
    }
  }
  /**
   *
   * @param gridApi api
   * @param selectIds éæ©çid
   * @param fcSelectedFieldName éé¡¹
   */
  doSelected(gridApi, selectIds, fcSelectedFieldName) {
    const clearTimer = (TIMER: any) => {
      clearInterval(TIMER);
      // this._gridApi.sizeColumnsToFit();
      // FclistdataBusiness.selectRowById(gridApi, selectIds, fcSelectedFieldName);
    };
    const timer = setInterval(() => {
      let flag = false;
      gridApi.forEachNode(node => {
        if (!flag) {
          flag = true;
        }
      });
      if (flag) {
        clearTimer(timer);
      }
    }, 500);
  }
  /**
   * ç¬¬ä¸æ¬¡æ°æ®æ¸²æçæ¶åè°ç¨
   * @param eventName säºä»¶
   * @param param åæ°
   */
  firstDataRendered(eventName, param) {
    setTimeout(() => {
      param.api.sizeColumnsToFit();
      this.event(eventName, param);
    }, 1);
  }
  /**
   * ç¬¬ä¸æ¬¡æ°æ®æ¸²æçæ¶åè°ç¨
   * @param param säºä»¶
   */
  _gridReady(params) {
    this._gridApi = params.api;
    this._gridColumnApi = params.columnApi;
    this.event('gridReady', params);
    this.doSelected(this._gridApi, this._selectIds, this.fcSelectedFieldName);
  }
  /**
   *
   * @param params å­æä½æé®äºä»¶
   */
  _doAction(params) {
    const param = params.data;
    const obj: any = {};
    Object.keys(param).forEach(key => {
      if (key !== 'DOACTION') {
        obj[key] = param[key];
      }
    });
    this.event(params.ACTION, obj);
  }
  /**
   * éä¸­äºä»¶
   * @param params åæ°
   */
  _selected(params) {
    const rows = this._gridApi.getSelectedRows();
    const datas: any[] = [];
    this._selectIds = [];
    this.fcSelectedValues = '';
    rows.forEach(item => {
      this._selectIds.push(item[this.fcSelectedFieldName]);
      this.fcSelectedValues += item[this.fcSelectedFieldName] + ',';
      datas.push(Object.assign({}, item, { DOACTION: '' }));
    });
    this.event('selected', datas);
  }
  _rowClick(params) {
    const rows = this._gridApi.getSelectedRows();
    const datas: any[] = [];
    rows.forEach(item => {
      const obj: any = {};
      Object.keys(item).forEach(key => {
        if (key !== 'DOACTION') {
          obj[key] = item[key];
        }
      });
      datas.push(obj);
    });
    this.event('rowClick', datas);
  }
  _cellClick(params) {
    const rows = this._gridApi.getSelectedRows();
    const datas: any[] = [];
    rows.forEach(item => {
      // tslint:disable-next-line:prefer-const
      let obj: any = {};
      Object.keys(item).forEach(key => {
        if (key !== 'DOACTION') {
          obj[key] = item[key];
        }
      });
      datas.push(obj);
    });
    let field: any = {
      FIELDCODE: params.colDef.field,
      FIELDNAME: params.colDef.headerName
    };
    if (this.fcApp) {
      const fields = this.fcApp.SYSAPPFIELDS.filter(
        f => f.FIELDCODE === params.colDef.field || f.FIELDCODE + '_DICDESC' === params.colDef.field
      );
      if (fields && fields.length !== 0) {
        field = fields[0];
      }
    }
    const param = {
      field,
      data: datas[0]
    };
    this.event('cellClick', param);
  }
  _rowDoubleClicked(params) {
    // tslint:disable-next-line:prefer-const
    let data = Object.assign({}, params.data, { DOACTION: '' });
    delete data.DOACTION;
    this.event('rowDoubleClick', data);
  }
  getPrevObj() {
    if (this._selectIndex === 1) {
      return;
    }
    this._selectIndex = this._selectIndex - 1;
    this._selectIds = [];
    this._selectItems = [];
    const selectedRows = this.fcRowData.filter(item => {
      return item.ROWNUM === this._selectIndex;
    });
    selectedRows.forEach(element => {
      this._selectIds.push(element.ID);
      this._selectItems.push(element);
    });
    return this._selectItems[0];
  }
  getNextObj() {
    if (this._selectIndex === this.fcRowData.length + 1) {
      return;
    }
    this._selectIds = [];
    this._selectItems = [];
    this._selectIndex = this._selectIndex + 1;
    const selectedRows = this.fcRowData.filter(item => {
      return item.ROWNUM === this._selectIndex;
    });
    selectedRows.forEach(element => {
      this._selectIds.push(element.ID);
      this._selectItems.push(element);
    });
    return this._selectItems[0];
  }
  _cellStopEdit(param) {
    param.data.oldValue = param.oldValue;
    param.data.newValue = param.newValue;
    const newObj = param.data;
    const fieldName = param.colDef.field;
    if (fieldName.indexOf('_DICDESC') !== -1) {
      const fieldCode = fieldName.substr(0, fieldName.length - 8);
      const dicdetails = this.appService.getDicByAppFieldcode(
        this.fcApp,
        fieldCode
      );
      const dics = dicdetails.filter(dic => dic.DICDESC === param.newValue);
      newObj[fieldCode] = dics[0].DICVALUE;
      if (this.fcOption.fcAutoSave) {
        const obj = Object.assign({}, newObj, { DOACTION: '' });
        this.pushDestroy(
          this.appService.updateObject(this.fcAppid, obj).subscribe(result => {
            if (result.CODE === '0') {
              this.msgService.success('ä¿®æ¹æå');
            }
          })
        );
      }
    }
    this.event('modify', newObj);
  }
  public setSelected(selectIds: string[]) {
    selectRowById(
      this._gridApi,
      selectIds,
      this.fcSelectedFieldName
    );
  }
}
